<template>
  <div class="input-container">
    <label
      for="us_phone"
      class="input__label"
    >Phone number</label>
    <input
      id="us_phone"
      v-model.lazy="$v.usPhone.$model"
      class="input "
      :class="{'input--error' : ($v.usPhone.$invalid === true && $v.usPhone.$error === true) }"
      type="tel"
      name="us_phone"
      @input="onInput($event)"
      @keypress="delayTouch($v.usPhone)"
      @focusout="updatePhone"
    >
    <span
      v-show="$v.usPhone.$invalid === true && $v.usPhone.$error === true"
      class="input__error"
    >
      Invalid Phone Number
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'

const touchMap = new WeakMap()
export default {
  props: {
    phoneProp: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      usPhone: ''
    }
  },
  watch: {
    '$v.usPhone.$invalid': function (value) {
      this.$emit('valid', (value === false), this.$options._componentTag)
    }
  },
  mounted () {
    if (this.phoneProp) { this.usPhone = this.phoneProp }
  },
  methods: {
    onInput: function (e) {
      this.usPhone = e.target.value
      let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
      //        e.target.setSelectionRange(e.target.value.length, e.target.value.length)
      setTimeout(() => e.target.setSelectionRange(e.target.value.length, e.target.value.length), 0)
    },
    updatePhone () {
      this.$emit('input', this.usPhone)
    },
    triggerTouch () {
      this.$v.$touch()
    },
    delayTouch ($v) {
      $v.$reset()
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v))
      }
      touchMap.set($v, setTimeout($v.$touch, 1000))
    }
  },
  validations: {
    usPhone: {
      required,
      isValidUsPhone (val) {
        if (val === '') return true
        if (val.length !== 14) return false
        return axios.post('//' + process.env.VUE_APP_LINK + '/api/validate/phone', { number: val })
          .then((response) => {
            if (response.data.valid !== false) {
              this.$emit('input', val)
              return true
            } else {
              return false
            }
          })
          .catch((error) => {
            console.log(error)
            return false
          })
      }
    }
  }
}
</script>
